import React from "react";
import { message } from "antd";

import { DeleteIcon } from "src/components";
import { compose } from "src/helpers";
import { withDeleteOrder } from "src/modules/order/operations";
import { captureException } from "@sentry/react";

const DeleteView = (props) => {
    const { deleteOrder, id } = props;

    const handleDelete = async () => {
        try {
            await deleteOrder(id);
            message.success("Deleted!");
        } catch (err) {
            captureException(err)
            message.error("Failed!");
        }
    };

    return <DeleteIcon {...props} onConfirm={handleDelete} />;
};

export default compose(withDeleteOrder)(DeleteView);
